const sixOneSchema = {
  title: "6_1 Indirect GHG Emissions from other sources",
  addAPI: "cat6_1AddEmissionActivityAPI",
  cat: "cat6_1",
  EATitle: "Emission Activity",
  fields: [
    {
      key: "itemName",
      level: 1,
      type: "input",
      label: "Activity Name",
      resetOnChange: false,
      required: true,
    },
  ],
};
export default sixOneSchema;
